import { message } from "antd";
import { useAuth } from "navigation/Auth/ProvideAuth";
import CodeVerificationWidget from "components/CodeVerificationWidget/CodeVerificationWidget";

import { REGISTER_WITH } from "config/CONSTANTS";
import {
  ROUTE_BECOME_VENDOR,
  ROUTE_DASHBOARD,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_LOGIN,
  ROUTE_REGISTER,
  ROUTE_SIGNUP,
} from "navigation/CONSTANTS";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { UpdateCurrentRoot, UpdateQrCodeList } from "redux/actions/appActions";
import { updateUser } from "redux/actions/userActions";
import InputPage from "./InputPage";
import { showChooseTypeDialog } from "pages/HomePage/Layout/ChooseTypeDialog/showChooseTypeDialog";

const LOGIN_PAGES = {
  InputPage: "InputPage",
  ActivationCodePage: "ActivationCodePage",
  InputLocationPage: "InputLocationPage",
};
const pageList = [
  LOGIN_PAGES.InputPage,
  LOGIN_PAGES.ActivationCodePage,
  LOGIN_PAGES.InputLocationPage,
];
function ForgotPasswordPage(props) {
  const appDataStore = useSelector((x) => x.appDataStore);
  const dispatch = useDispatch();
  const auth = useAuth();
  const [userDetail, setUserDetail] = useState({
    email: "",
    password: "",
    token: "",
    code: "",
    confirm_password: ""
  });
  const [isBusy, setIsBusy] = useState(false);
  const [registrationInfo, setRegistrationInfo] = useState(null);
  const [step, setStep] = useState(0);
  useEffect(() => {
    dispatch(updateUser({ token: undefined }));
    if (appDataStore?.appInfo?.registration_info) {
      setRegistrationInfo(appDataStore?.appInfo?.registration_info)
    } else {
      setRegistrationInfo(null);
    }
  }, []);

  const onClickLogin = async () => {
    props.history.replace(ROUTE_LOGIN);

  };
  const onSubmit = () => {
    if (step == 0) {
      onForgotPassword();
    } else if (step == 1) {
      onConfirmCode();
    } else if (step == 2) {
      onChangePassword();
    }
  };

  const onForgotPassword = () => {
    setIsBusy(true)
    auth
      .forgotPassword(userDetail)
      .then((res) => {
        setIsBusy(false)
        if (res.result) {
          setStep(1)
          message.success(res.msg)
        } else {
          message.error(res.msg)
        }
      })
      .catch((err) => {
        setIsBusy(false)
        message.error(err);
      });
  }
  const onConfirmCode = () => {
    setIsBusy(true)
    auth
      .confirmCode(userDetail)
      .then((res) => {
        setIsBusy(false)
        if (res.result) {
          setStep(2)
          setUserDetail({ ...userDetail, token: res.msg })
        } else {
          message.error(res.msg)
        }
      })
      .catch((err) => {
        setIsBusy(false)
        message.error(err);
      });
  }
  const onChangePassword = () => {
    setIsBusy(true)
    auth
      .changePassword(userDetail)
      .then((res) => {
        setIsBusy(false)
        if (res.result) {
          message.success(res.msg)
          onClickLogin();
        } else {
          message.error(res.msg)
        }
      })
      .catch((err) => {
        setIsBusy(false)
        message.error(err);
      });
  }
  return (
    <div style={{ color: 'var(--blackColor)', backgroundColor: 'var(--whiteColor)' }}>
      <InputPage
        onClickLogin={onClickLogin}
        onSubmit={onSubmit}
        userDetail={userDetail}
        setUserDetail={setUserDetail}
        isBusy={isBusy}
        registrationInfo={registrationInfo}
        step={step}
        setStep={setStep}
      />
    </div>
  );
}

export default withRouter(ForgotPasswordPage);
